import { Heart } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-sm text-gray-400">
            © 2024 FENAE Sorteios. Todos os direitos reservados.
          </p>
          <p className="text-xs text-gray-500 mt-2 flex items-center justify-center">
            Feito com <Heart className="h-3 w-3 text-red-500 mx-1" /> pela equipe FENAE
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
